import { render } from "./DAICreateView.vue?vue&type=template&id=7588c2ef&scoped=true"
import script from "./DAICreateView.vue?vue&type=script&lang=js"
export * from "./DAICreateView.vue?vue&type=script&lang=js"

import "./DAICreateView.vue?vue&type=style&index=0&id=7588c2ef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7588c2ef"]])

export default __exports__